import { Modal } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import { checkAccount, deleteToken } from 'services/auth';
import { getAvailableVdGroups } from 'services/mgmt';
import { assignVd } from 'services/session';
import * as VsclientService from 'services/vsclient';
import { connectByVdStart, getXauthFromCookie, startAgent } from './utils';

function URLRedirectPage({ history, location }) {
  const redirectUrl = decodeURIComponent(location?.search?.split('?url=')[1]);

  const redirect = async (vdGroup, token) => {
    const searchParam = {
      'conn-req-url': `${window.location.protocol}//${window.location.host}/portal/api/session/vdgroups/${vdGroup.id}/connection`,
      'conn-token': token,
      username: localStorage.getItem('username'),
      'redirect-url': redirectUrl,
    };

    // vsclient에게 넘겨줄 args
    const args = new URLSearchParams(searchParam).toString();
    try {
      await VsclientService.checkClagent();
    } catch (error) {
      await startAgent(2);
    }

    window.location = `http://localhost:61811/vsclient/redirect-url?args=${btoa(args)}`;
  };

  const redirectWithoutToken = async () => {
    const searchParam = {
      'redirect-url': redirectUrl,
    };

    // vsclient에게 넘겨줄 args
    const args = new URLSearchParams(searchParam).toString();
    try {
      await VsclientService.checkClagent();
    } catch (error) {
      await startAgent(2);
    }
    window.location = `http://localhost:61811/vsclient/redirect-url?args=${btoa(args)}`;
  };

  useEffect(async () => {
    const getRedirectVd = async (token) => {
      const res = await getAvailableVdGroups();

      if (res.status !== 'error' && res.data.length === 0) {
        Modal.warning({
          message: 'URL Redirection 실패',
          description: '가용한 Desktop이 없습니다.',
        });

        return;
      }

      if (res.status === 'error') {
        Modal.warning({
          message: 'URL Redirection 실패',
          description: res.errorMsg,
        });
        return;
      }

      let index = -1;
      res.data.forEach((d, idx) => {
        if (d.autoLogin === true) {
          index = idx;
        }
      });

      if (index !== -1) {
        // eslint-disable-next-line no-unused-expressions
        if (res.data[index].state.endsWith('.state.stopped')) {
          connectByVdStart(res.data[index], moment().add(3, 'm'), (groupInfo) =>
            redirect(groupInfo, token),
          );
        } else if (!res.data[index].vdName) {
          // VD에 할당되어있지 않은 경우
          // 1. 할당해라
          // 2. 접속해라
          const vd = (await assignVd(res.data[index].id)).data;

          // eslint-disable-next-line no-unused-expressions
          vd.state.endsWith('stopped')
            ? connectByVdStart(vd, moment().add(3, 'm'), (groupInfo) => redirect(groupInfo, token))
            : redirect(vd, token);
        } else {
          redirect(res.data[index], token);
        }
      }
    };

    const token = getXauthFromCookie();

    if (!token) {
      try {
        const result = await VsclientService.isRunning();
        if (result.data === true) {
          await redirectWithoutToken();
        }
      } catch (e) {
        // 아무일 안함
      }

      history.push({
        pathname: '/auth/login',
        redirectUrlToVd: redirectUrl,
      });
    } else {
      // 토큰은 존재하나 패스워드가 변경되어 인증에 실패한 경우를 처리
      try {
        await checkAccount(token);
      } catch (e) {
        Modal.warning({
          title: '인증 실패',
          content: '로그인 세션이 만료되었거나 패스워드가 변경되었을 수 있습니다.',
          onOk: async () => {
            await deleteToken();
            history.push({
              pathname: '/auth/login',
              redirectUrlToVd: redirectUrl,
            });
          },
        });
        return;
      }

      await getRedirectVd(token);
    }
  }, []);

  return <></>;
}

export default URLRedirectPage;
